<template>
  <div class="inspection-point-manage">
    <!-- 导航提示标题 -->
    <ml-tip :showHeader="false" content="巡检点位管理" />
    <!-- 搜索框 -->
    <ml-tip :showHeader="false" style="border: 0">
      <ml-form inline labelWidth="100px" :model="searchData" ref="searchDataRef">
        <!-- 关键词 -->
        <ml-input
          prop="keyword"
          placeholder="请输入点位名称"
          style="margin-bottom: 0"
          label="关键词:"
          v-model="searchData.keyword"
        />
        <!-- 阿米巴 -->
        <ml-select
          prop="companyId"
          placeholder="请选择阿米巴"
          :options="unitOptions"
          label="阿米巴:"
          keyName="companyId"
          labelName="companyName"
          valueName="companyId"
          v-model="searchData.companyId"
          style="margin-bottom: 0"
        />
        <!-- 所属项目 -->
        <ml-select
          prop="projectId"
          placeholder="请选所属项目"
          :options="projectData"
          label="所属项目:"
          keyName="projectId"
          labelName="projectName"
          valueName="projectId"
          v-model="searchData.projectId"
          :style="{ marginBottom: 0 }"
          @change="searchFn"
        />
        <!-- 搜索按钮 -->
        <ml-button
          :style="{ 'margin-bottom': 0 }"
          submitText="搜索"
          submitIcon="el-icon-search"
          cancelText="重置"
          cancelIcon="el-icon-refresh"
          cancelType="danger"
          @click-cancel="resetSearchData"
          @click-submit="searchFn"
        />
      </ml-form>
      <div class="add-btn-box">
        <el-button-group>
          <el-button icon="el-icon-plus" type="primary" @click="addHandle">新增点位</el-button>
          <el-button icon="el-icon-upload2" type="primary" @click="inspectionPointExcelImport">
            批量导入
          </el-button>
          <el-button icon="el-icon-download" type="primary" @click="batchQrCodeDownloadHandle">
            批量下载二维码
          </el-button>
        </el-button-group>
      </div>
    </ml-tip>
    <!-- 数据表格 -->
    <ml-tip :showHeader="false" class="default-tip" style="margin-bottom: 0">
      <!-- 表格 -->
      <el-table :data="tabberData.data" style="width: 100%" :height="tabberHeight(360)">
        <el-table-column align="center" type="index" width="80">
          <template #default="scope">
            {{ (tabberData.page - 1) * tabberData.size + (scope.$index + 1) }}
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          label="点位编号"
          prop="pointCode"
          min-width="10%"
        />
        <el-table-column
          show-overflow-tooltip
          align="center"
          label="点位名称"
          prop="pointName"
          min-width="12%"
        />
        <el-table-column
          show-overflow-tooltip
          align="center"
          label="阿米巴"
          prop="companyName"
          min-width="12%"
        />
        <el-table-column
          show-overflow-tooltip
          align="center"
          label="所属项目"
          prop="projectName"
          min-width="15%"
        />
        <el-table-column
          show-overflow-tooltip
          align="center"
          label="经纬度"
          min-width="10%"
        >
          <template #default="scope">
            {{ scope.row.longitude }},{{ scope.row.latitude }}
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          label="地址"
          prop="pointAddr"
          min-width="10%"
        />
        <el-table-column
          show-overflow-tooltip
          align="center"
          label="点位分类"
          min-width="8%"
        >
          <template #default="scope">
            {{ pointTypeMap[scope.row.pointType] || scope.row.pointType }}
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          label="状态"
          min-width="8%"
        >
          <template #default="scope">
            <span :style="{ color: scope.row.dataStatus === '1' ? '#00b42a' : '#f53f3f' }">
              {{ scope.row.dataStatus === '1' ? '启用' : '停用' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="20%">
          <template #default="scope">
            <el-button
              size="mini"
              icon="el-icon-picture-outline"
              type="success"
              @click="showQrCode(scope.row)"
            >
              二维码
            </el-button>
            <el-button
              size="mini"
              icon="el-icon-edit"
              type="primary"
              @click="clickEdit(scope.$index, scope.row)"
            >
              编辑
            </el-button>
            <el-button
              size="mini"
              icon="el-icon-delete"
              type="danger"
              @click="clickDelete(scope.$index, scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <ml-pagination
        :total="tabberData.total"
        :page="tabberData.page"
        v-model="tabberData.page"
        :size="tabberData.size"
        @current-change="currentChange"
        @size-change="sizeChange"
      />
    </ml-tip>
    <!-- 导入文件提示框 -->
    <ml-dialog width="600px" ref="importPointDialogRef" title="批量导入" :showSubmitBtn="false">
      <template #body>
        <div class="import-equipment-dialog-box">
          <ml-form ref="uploadRef" labelWidth="100px" :model="uploadForm" :rules="uploadFormRules">
            <!-- 阿米巴 -->
            <ml-select
              prop="companyId"
              placeholder="请选择阿米巴"
              :options="unitOptions"
              label="阿米巴:"
              keyName="companyId"
              labelName="companyName"
              valueName="companyId"
              v-model="uploadForm.companyId"
              style="margin-bottom: 16px"
            />
            <!-- 所属项目 -->
            <ml-select
              prop="projectId"
              placeholder="请选所属项目"
              :options="projectOptionsData"
              label="所属项目:"
              keyName="projectId"
              labelName="projectName"
              valueName="projectId"
              v-model="uploadForm.projectId"
              :style="{ marginBottom: '16px'}"
            />
            <el-form-item label="导入文件:" prop="file">
              <ml-upload
                ref="importPointUploadRef"
                :showFileList="false"
                :autoUpload="false"
                @on-change="onChange"
                accept=".xls, .xlsx"
              >
                <el-button icon="el-icon-upload2" type="primary">批量导入</el-button>
              </ml-upload>
            </el-form-item>
          </ml-form>
          <div class="import-equipment-dialog">
            <span>请导入与巡检点位信息表格匹配的文件还无模板？</span>
            <el-button type="text" @click="downloadModel">点击下载模板</el-button>
          </div>
        </div>
      </template>
    </ml-dialog>
    <!-- 二维码弹窗 -->
    <ml-dialog
      width="400px"
      ref="qrCodeDialogRef"
      title="巡检点位二维码"
      :showSubmitBtn="false"
      :showCloseBtn="true"
    >
      <template #body>
        <div style="text-align: center; padding: 10px 0">
          <div style="margin-bottom: 8px; font-size: 15px">{{ qrCodeData.pointName }}</div>
          <img
            v-if="qrCodeData.qrCodeUrl"
            :src="qrCodeData.qrCodeUrl"
            style="border: 1px solid #eee; max-width: 200px; max-height: 200px"
          />
          <div v-else style="color: #999; padding: 20px">暂无二维码</div>
        </div>
      </template>
    </ml-dialog>
    <!-- 删除提示框 -->
    <ml-dialog
      ref="deleteUserDialogRef"
      :content="deleteUserData.content"
      @click-submit="submitDeleteUser"
    />
  </div>
</template>
<script>
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { exportInspectionPointQrCodeDownload, exportInspectionPointTemplateRequest } from '@/API/previewApi'
import {
  tabberHeight,
  searchParams,
  getTabberData,
  downloadFile,
  clearMemoryPageFn,
  replacePerCent
} from '@/utils'
export default {
  setup() {
    const { commit, getters, dispatch } = useStore()
    const router = useRouter()
    const isBusinessDepartment = computed(() => getters.isBusinessDepartment)
    const getMemoryPage = computed(() => getters.getMemoryPage)
    /* 点位分类映射 */
    const pointTypeMap = {
      '1': '硬件设备',
      '2': '建筑物',
      '3': '地理位置'
    }

    /* 开始 搜索 **********************************/
    // 搜索条件
    const searchDataRef = ref()
    const searchData = reactive({
      keyword: getMemoryPage.value.searchData.keyword || '',
      companyId: getMemoryPage.value.searchData.companyId || '',
      projectId: getMemoryPage.value.searchData.projectId || ''
    })
    // 表格配置
    const tabberData = reactive({
      data: [],
      total: 0,
      page: getMemoryPage.value.page || 1,
      size: getMemoryPage.value.size || 10
    })
    // 重置搜索内容
    const resetSearchData = () => {
      searchDataRef.value.CustomFormRef.resetFields()
      clearMemoryPageFn(commit, searchData)
      tabberData.page === 1 ? getInspectionPoints() : (tabberData.page = 1)
    }
    // 搜索
    const searchFn = () => {
      tabberData.page === 1 ? getInspectionPoints() : (tabberData.page = 1)
    }
    // 单位配置
    const unitOptions = ref([])
    // 所属项目配置
    const projectData = ref([])
    watch(
      () => searchData.companyId,
      newvalue => {
        if (newvalue) {
          getProjectData(newvalue)
        } else {
          projectData.value = []
        }
      }
    )
    // 处理所属项目
    const getProjectData = async companyId => {
      const projectParams = {}
      if (isBusinessDepartment.value && companyId) {
        projectParams.companyId = companyId
      }
      const { data } = await getTabberData(dispatch, 'fetchGetProjectsByCompany', projectParams)
      projectData.value = data || []
    }

    /* 开始 数据列表 **********************************/
    //分页事件
    watch([() => tabberData.page, () => tabberData.size], () => {
      getInspectionPoints()
    })
    const currentChange = page => {
      tabberData.page = page
    }
    const sizeChange = size => {
      tabberData.size = size
    }
    // 获取列表
    const getInspectionPoints = async (
      params = { pageIndex: tabberData.page, pageSize: tabberData.size }
    ) => {
      const searchDataParams = searchParams(searchData)
      searchDataParams.keyword = replacePerCent(searchData.keyword)
      const { data } = await getTabberData(
        dispatch,
        'fetchGetInspectionPointPage',
        params,
        searchDataParams
      )
      tabberData.data = data.records || []
      tabberData.total = data.total || 0
    }

    // 下载模板
    const downloadModel = () => {
      exportInspectionPointTemplateRequest()
        .then(res => {
          const fileName = '巡检点位导入模板.xlsx'
          downloadFile(res.data, fileName)
        })
        .catch(error => {
          console.log(error)
        })
    }

    /* 导入 操作 **********************************/
    const uploadForm = reactive({
      companyId: '',
      projectId: ''
    })
    const uploadFormRules = reactive({
      companyId: [
        {
          required: true,
          message: '请选择阿米巴',
          trigger: 'blur'
        }
      ],
      projectId: [
        {
          required: true,
          message: '请选择项目',
          trigger: 'blur'
        }
      ]
    })
    const projectOptionsData = ref([])

    watch(
      () => uploadForm.companyId,
      newvalue => {
        uploadForm.projectId = ''
        if (newvalue) {
          getProjectOptionsData(newvalue)
        } else {
          projectOptionsData.value = []
        }
      }
    )
    // 处理所属项目
    const getProjectOptionsData = async companyId => {
      const projectParams = {}
      if (isBusinessDepartment.value && companyId) {
        projectParams.companyId = companyId
      }
      const { data } = await getTabberData(dispatch, 'fetchGetProjectsByCompany', projectParams)
      projectOptionsData.value = data || []
    }

    const uploadRef = ref(null)
    // 导入
    const importPointDialogRef = ref()
    const importPointUploadRef = ref()
    const inspectionPointExcelImport = () => {
      uploadForm.companyId = ''
      uploadForm.projectId = ''
      importPointDialogRef.value.showDialog = true
    }
    const onChange = (ev, file) => {
      if (file && file.length > 0) {
        const ImportFormData = new FormData()
        ImportFormData.append('file', file[0].raw)
        ImportFormData.append('companyId', uploadForm.companyId)
        ImportFormData.append('projectId', uploadForm.projectId)
        importPointUploadRef.value.CustomUploadRef.uploadFiles = []
        uploadRef.value.CustomFormRef.validate().then(() => {
          dispatch('fetchImportInspectionPoint', ImportFormData).then(data => {
            if (data && data.code === 200) {
              tabberData.page === 1 ? getInspectionPoints() : (tabberData.page = 1)
              importPointDialogRef.value.showDialog = false
            }
            commit('setError', {
              status: true,
              title: data.message,
              message: '正在获取新的数据...',
              type: 'success'
            })
          })
        })
      }
    }

    // 批量下载二维码
    const batchQrCodeDownloadHandle = () => {
      const searchDataParams = searchParams(searchData)
      searchDataParams.keyword = replacePerCent(searchData.keyword)
      searchDataParams.pageIndex = 1
      searchDataParams.pageSize = tabberData.total || 10000
      exportInspectionPointQrCodeDownload(searchDataParams)
        .then(res => {
          const fileName = '巡检点位二维码.zip'
          downloadFile(res.data, fileName)
        })
        .catch(error => {
          console.log(error)
        })
    }

    // 删除
    const deleteUserDialogRef = ref()
    const deleteUserData = reactive({
      content: '确定删除该巡检点位吗？',
      id: ''
    })

    const clickDelete = (index, row) => {
      deleteUserData.id = row.id
      deleteUserDialogRef.value.showDialog = true
    }
    // 确定删除
    const submitDeleteUser = () => {
      const { id } = deleteUserData
      dispatch('fetchDeleteInspectionPoint', { id: id }).then(data => {
        if (data && data.code === 200) {
          commit('setError', {
            status: true,
            title: data.message,
            message: '正在获取新的数据...',
            type: 'success'
          })
          tabberData.page === 1 ? getInspectionPoints() : (tabberData.page = 1)
          deleteUserDialogRef.value.showDialog = false
        }
      })
    }

    /* 二维码弹窗 */
    const qrCodeDialogRef = ref()
    const qrCodeData = reactive({
      pointName: '',
      qrCodeUrl: ''
    })
    const showQrCode = row => {
      qrCodeData.pointName = row.pointName || ''
      qrCodeData.qrCodeUrl = ''
      dispatch('fetchGetInspectionPointQrCode', { pointId: row.id }).then(data => {
        if (data && data.data) {
          const base64 = data.data
          qrCodeData.qrCodeUrl = base64.startsWith('data:') ? base64 : 'data:image/png;base64,' + base64
        }
        qrCodeDialogRef.value.showDialog = true
      }).catch(() => {
        qrCodeDialogRef.value.showDialog = true
      })
    }

    /* 开始 新增/修改 **********************************/
    const addHandle = () => {
      router.push({ path: '/inspectionPointAction' })
    }
    const clickEdit = (index, row) => {
      router.push({ path: '/inspectionPointAction', query: { pointId: row.id } })
    }

    onMounted(async () => {
      // 获取单位名
      const { data } = await getTabberData(dispatch, 'fetchGetCompanyInfos', {
        noCompanyCode: 'business_department'
      })
      unitOptions.value = data || []
      getInspectionPoints()
    })
    return {
      searchDataRef,
      searchData,
      resetSearchData,
      searchFn,
      getInspectionPoints,
      tabberData,
      tabberHeight,
      currentChange,
      sizeChange,
      unitOptions,
      getProjectData,
      projectData,
      downloadModel,
      importPointDialogRef,
      importPointUploadRef,
      inspectionPointExcelImport,
      onChange,
      clickDelete,
      submitDeleteUser,
      deleteUserDialogRef,
      deleteUserData,
      addHandle,
      clickEdit,
      pointTypeMap,
      uploadForm,
      uploadFormRules,
      uploadRef,
      projectOptionsData,
      batchQrCodeDownloadHandle,
      qrCodeDialogRef,
      qrCodeData,
      showQrCode
    }
  }
}
</script>
<style scoped>
.inspection-point-manage {
  padding: 0;
}
.add-btn-box {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}
.import-equipment-dialog-box {
  padding: 0 20px;
}
.import-equipment-dialog {
  margin-top: 10px;
  font-size: 13px;
  color: #666;
}
</style>